import React, {useContext} from 'react';
import {Switch, Route, useHistory} from 'react-router-dom';
import {Footer} from './components';
import {SideNavOuterToolbar as SideNavBarLayout} from './layouts';
import appInfo from './app-info';
import ordersRoute from './components/top-navigation/orders/routes';
import shipmentsRoute from './components/top-navigation/shipments/routes';
import settingsRoute from './components/top-navigation/settings/routes';
import productsRoute from './components/top-navigation/products/routes';
import dashboardRoute from './components/top-navigation/dashboard/routes';
import customersRoute from './components/top-navigation/customers/routes';
import {NavbarContext} from './contexts/top-navigation';
import {Welcome} from './components'
import storesApi from './api/stores';
import notify from 'devextreme/ui/notify';
import Session from './sessions';

export default function () {
    const menu = useContext(NavbarContext);
    const history = useHistory();
    const userId =  Session.getSession("user")?.id;
    const auth = Session.getSession("user")?.access_token;
    var href = window.location.href.split("/");
    var exthref = window.location.href.split("?");

    if (exthref[1] !== undefined) {
        if(exthref[1].includes('hmac') || exthref[1].includes('state=amz')) {//this is for shopify and amazon
            window.location.href=`/#/settings/stores?${exthref[1]}`;
        }
        //console.log("query",href[5]);
        const url =href[5].toString();
        try{
            storesApi.getAccessToken(url,auth).then(res => {
                //console.log("Access Token", res)
                const type = res.data.type;
                const name = res.data.shopname;
                const amz_sellerID = res.data.data?.selling_partner_id; //only for amazon
                const code = (type) => {
                    switch(type){
                        case 'ebay':
                            return res.data.data.access_token;
                        case 'etsy':
                            return  res.data.data.token;
                        case 'shopify':
                            return res.data.data.access_token;
                        case 'amazon':
                            return res.data.data.access_token; 
                        default:
                            return "";
                    }
                }
                const refreshCode = (type) => {
                    switch(type){
                        case 'ebay':
                            return res.data.data.refresh_token;
                        case 'etsy':
                            return  res.data.data.tokenSecret;
                        case 'shopify':
                            return  res.data.data.scope;
                        case 'amazon':
                            return res.data.data.refresh_token;
                        default:
                            return "";
                    }
                }
    
                if (res.status === 200) {
                    storesApi.createStore({"userId":userId,"type": type, "name": name, "code": code(type),"refreshCode": refreshCode(type),"selling_partner_id":amz_sellerID},auth).then((res)=>{
                        if(res.status === 201){
                            notify(`${type} store added succesfully`, "success", 500);
                            history.replace(`/settings/stores`);
                            window.location.reload();
                        }
                        else{
                            notify(res?.message? res.message : "there is something wrong", "warning", 500);
                        }
                    })
                }
            }).catch(err=>{
                console.log(err);
            });
        }catch(err){
            console.log(err);
        }
    }

    const Routes = () => {
        switch(menu.menuID ? menu.menuID : href[4]){
            case 'dashboard':
                return(
                    dashboardRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
                );
            case 'orders':
                return(
                    ordersRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
                );
            case 'shipments':
                return(
                    shipmentsRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
                );
            case 'products':
                return(
                    productsRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
                );
            case 'customers': 
                return(
                    customersRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
                );
            case 'settings':
                return(
                    settingsRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
                );
            case 'quick-setup':
                return(
                    <Route exact path='/quick-setup'>
                        <Welcome />
                    </Route>
                );
            default:
                return(
                    dashboardRoute.map(({path, component}) => (<Route exact key={path} path={path} component={component}/>))
                );
        }
    }

    return (
        <React.Fragment>
            <SideNavBarLayout title={appInfo.title}>
                <Switch>
                    <Routes />
                </Switch>
                <Footer>
                    Copyright © 2020 {appInfo.company}
                    <br/>
                    All trademarks or registered trademarks are property of their respective owners.
                </Footer>
            </SideNavBarLayout>
        </React.Fragment>
    );
}
